import { useState } from "react";

export function useLocalStorageTab<TTabId extends string>(
    storageKey: string,
    tabMapping: Record<number, TTabId>,
    defaultTabId: TTabId
): [number, (index: number) => void] {
    const [storedTabId, setStoredTabId] = useState<string>(() => localStorage.getItem(storageKey) ?? defaultTabId);

    const resolveIndex = (id: string) => {
        const entry = Object.entries(tabMapping).find(([, tabId]) => tabId === id);
        return entry ? Number(entry[0]) : undefined;
    };

    const resolveId = (index: number) => {
        return tabMapping[index] ?? defaultTabId;
    };

    const selectedTab = resolveIndex(storedTabId) ?? resolveIndex(defaultTabId)!;

    const setSelectedTab = (index: number) => {
        const tabId = resolveId(index);
        setStoredTabId(tabId);
        localStorage.setItem(storageKey, tabId);
    };

    return [selectedTab, setSelectedTab];
}
